<template>
  <div id="container">
    <div class="item-box-content-table">
      <div class="title-font-style">
        <span>收票信息</span>
      </div>
      <div class="search-style" style="padding:20px 30px 20px 30px">
        <el-form label-width="70px">
          <el-row :gutter="20" style="margin-bottom:20px;">
            <el-col :span="8">
              <el-form-item label="发票类型：">
                <el-select v-model="queryParams.invoiceType">
                  <el-option
                    v-for="(item, index) in invoiceTypeData"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收票类型：">
                {{
                queryParams.bilingType
                }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="收票公司：">
                {{
                queryParams.invoiceReceiveCompany
                }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="发票编号：">
                <el-input v-model="queryParams.invoiceNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="item-box-content-table">
      <div class="title-font-style">
        <span>收票清单</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <div class="join-remove-inline-block">
            <div class="title-content-table">待收票产品</div>

            <el-table
              border
              ref="tableRef"
              :data="waitTicketCollectionList"
              tooltip-effect="dark"
              @row-dblclick="RowDbclick"
              @selection-change="handleSelectionChangeTicketProductsList"
              :header-cell-style="tableHeader"
              v-loading="loadingWaitTable"
              height="423px"
              style="margin-top:34px;"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <template slot="empty">
                <span>产品已全部移入收票区！</span>
              </template>
              <el-table-column width="35" type="selection"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proOrdernum" label="订货号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="pcbNumber" label="采购合同编号" width="150px"></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="supplierContractNumber"
                label="供应商合同编号"
                width="120px"
              ></el-table-column>
              <el-table-column show-overflow-tooltip prop="purchasePrice" label="实付单价"></el-table-column>
              <el-table-column show-overflow-tooltip prop="deliverState" label="发货状态">
                <template slot-scope="scope">
                  {{
                  stateList[scope.row.deliverState-1]
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="count" label="数量"></el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-inline-block-btn">
              <el-button type="primary" @click="moveReportingAreaListAll">全部移入</el-button>
              <el-button type="primary" @click="moveReportingAreaList" plain>移入收票区</el-button>
            </el-col>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="join-remove-inline-block">
            <div style>
              <div class="title-content-table">收票产品区</div>
              <div style="text-align:right;color:#276CFF;">发票金额：{{(countAll/100) | priceFilterNum}}</div>
            </div>
            <el-table
              style="margin-top:14px;"
              border
              ref="tableRef"
              :data="ticketCollectionList"
              @selection-change="handleSelectionChangeTicketingAreaList"
              tooltip-effect="dark"
              @row-dblclick="RowDbclickReturn"
              :header-cell-style="tableHeader"
              height="423px"
            >
              <template slot="empty">
                <span>请选择收票产品！</span>
              </template>
              <el-table-column width="35" type="selection"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proModel" label="型号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="proOrdernum" label="订货号"></el-table-column>
              <el-table-column show-overflow-tooltip width="150px" prop="pcbNumber" label="采购合同编号"></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="supplierContractNumber"
                label="供应商合同编号"
                width="140px"
              ></el-table-column>
              <el-table-column show-overflow-tooltip prop="purchasePrice" label="实付单价"></el-table-column>
              <el-table-column show-overflow-tooltip prop="deliverState" label="发货状态">
                <template slot-scope="scope">
                  {{
                  stateList[scope.row.deliverState-1]
                  }}
                </template>
              </el-table-column>
              <el-table-column width="150px" prop="number" label="数量">
                <template slot-scope="scope">
                  <el-input-number
                    style="width:100%;"
                    controls-position="right"
                    v-model="scope.row.count"
                    @input="onNumber(scope.row)"
                    :max="scope.row.maxCount"
                    :min="1"
                    @change="handleChange"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-inline-block-btn">
              <el-button type="primary" @click="moveMissingProductsListAll">全部移出</el-button>
              <el-button type="primary" @click="moveMissingProductsList" plain>移出收票区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row style="margin-top:20px;">
      <el-col :span="24">
        <el-button @click="onApplyForTicketCollection" type="primary">申请收票</el-button>
      </el-col>
      <el-col :span="24" style="margin-top:16px;">请提交收票申请后，尽快将票据送至财务部</el-col>
    </el-row>
    <!-------------- 申请收票二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import {
  queryPageByProduct,
  addInvocie,
  addByMerge
} from '@/api/purchase/purchasePlanList'
export default {
  components: {
    'open-or-close': OpenOrClose
  },
  data () {
    return {
      stateList: ['物流在途', '验收', '已入库', '已作废', '已发货', '待发货', '报缺待处理', '报缺审核中', '报缺已处理'],
      invoiceTypeData: [
        { label: '普通发票', value: '普通发票' },
        { label: '专用发票', value: '专用发票' }
      ],
      type: '',
      onNumberObj: null,
      countAll: 0, // 总数
      ticketCollectionList: [], // 收票产品区
      queryParamsSearch: {},
      params: {},
      bigArray: [], // 最全数组
      changeMissingProductsList: [], // 收票产品选中
      changeReportingAreaList: [], // 待收票选中
      queryParams: {},
      shippedProductList: [],
      waitTicketCollectionList: [], // 待收票产品区
      loadingWaitTable: false,
      title: '',
      content: ''
    }
  },
  mounted () {
    if (this.$route.query.pcbId === undefined) {
      if (this.$store.state.ticketState.length === 0) {
        this.$router.push({
          name: 'notChecksContractList'
        })
      } else {
        this.ticketState = JSON.parse(
          JSON.stringify(this.$store.state.ticketState)
        )
        const params = JSON.parse(JSON.stringify(this.$store.state.ticketState))
        this.queryParams = params.purchaseContractInvocieInfoVo
        this.waitTicketCollectionList =
          params.purchaseContractInvocieProductVoList
        this.waitTicketCollectionList.forEach((item, index) => {
          this.waitTicketCollectionList[index].maxCount = item.count
          this.waitTicketCollectionList[index].id = index
        })
        this.bigArray = JSON.parse(
          JSON.stringify(this.waitTicketCollectionList)
        )
      }
    } else if (this.$route.query.pcbId !== undefined) {
      this.getList()
    }
  },
  methods: {
    // 待收票change
    handleSelectionChangeTicketProductsList (val) {
      this.changeReportingAreaList = val
    },
    // 收票change
    handleSelectionChangeTicketingAreaList (val) {
      this.changeMissingProductsList = val
    },
    // 收票All移动
    moveMissingProductsListAll () {
      this.changeMissingProductsList = JSON.parse(
        JSON.stringify(this.ticketCollectionList)
      )
      this.moveMissingProductsList()
    },
    // 收票移动

    moveMissingProductsList () {
      if (this.changeMissingProductsList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeMissingProductsList.forEach((param) => {
          this.ticketCollectionList.forEach((item, index) => {
            if (item.id === param.id) {
              let isFalse = false
              if (this.waitTicketCollectionList.length > 0) {
                this.waitTicketCollectionList.forEach((val, indexs) => {
                  if (val.id === param.id) {
                    this.waitTicketCollectionList[
                      indexs
                    ].count += this.ticketCollectionList[index].count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.waitTicketCollectionList.push(
                    this.ticketCollectionList[index]
                  )
                }
              } else {
                this.waitTicketCollectionList.push(
                  this.ticketCollectionList[index]
                )
              }
            }
          })
        })
        this.changeMissingProductsList.forEach((param) => {
          this.ticketCollectionList.forEach((item, index) => {
            if (item.id === param.id) {
              this.ticketCollectionList.splice(index, 1)
              index--
            }
          })
        })
      }
      this.changeMissingProductsList = []
    },
    // 移入收票区All
    moveReportingAreaListAll () {
      this.changeReportingAreaList = JSON.parse(
        JSON.stringify(this.waitTicketCollectionList)
      )
      this.moveReportingAreaList()
    },
    // 移入收票区
    moveReportingAreaList () {
      if (this.changeReportingAreaList.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.changeReportingAreaList.forEach((param) => {
          this.waitTicketCollectionList.forEach((item, index) => {
            if (item.id === param.id) {
              let isFalse = false
              if (this.ticketCollectionList.length > 0) {
                this.ticketCollectionList.forEach((val, indexs) => {
                  if (val.id === item.id) {
                    this.ticketCollectionList[
                      indexs
                    ].count += this.waitTicketCollectionList[index].count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.ticketCollectionList.push(
                    this.waitTicketCollectionList[index]
                  )
                }
              } else {
                this.ticketCollectionList.push(
                  this.waitTicketCollectionList[index]
                )
              }
            }
          })
        })
        this.changeReportingAreaList.forEach((param) => {
          this.waitTicketCollectionList.forEach((item, index) => {
            if (item.id === param.id) {
              this.waitTicketCollectionList.splice(index, 1)

              index--
            }
          })
        })
      }
      this.changeReportingAreaList = []
    },
    onNumber (row) {
      this.onNumberObj = row
    },
    // 数字改变
    handleChange (newVal = 0, old) {
      let count = 0

      count = old - newVal

      let isBooean = false
      this.waitTicketCollectionList.forEach((item, indexProductsList) => {
        if (this.onNumberObj.id === item.id) {
          isBooean = true
          item.count += count
        }
      })
      if (!isBooean) {
        const params = JSON.parse(JSON.stringify(this.onNumberObj))
        params.count = count
        this.waitTicketCollectionList.push(params)
      }

      this.clearList()
    },
    RowDbclickReturn (row) {
      this.changeMissingProductsList = [row]
      this.moveMissingProductsList()
    },
    RowDbclick (row) {
      this.changeReportingAreaList = [row]
      this.moveReportingAreaList()
    },
    clearList () {
      this.ticketCollectionList.forEach((item, indexProductsList) => {
        if (item.count === 0 || !item.count) {
          this.ticketCollectionList.splice(indexProductsList, 1)
        }
      })
      this.waitTicketCollectionList.forEach((item, indexAreaList) => {
        if (item.count === 0) {
          this.waitTicketCollectionList.splice(indexAreaList, 1)
        }
      })
    },
    // 获取数据
    getList () {
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }
      queryPageByProduct(this.$route.query.pcbId, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.purchaseContractInvocieInfoVo
            this.waitTicketCollectionList =
              res.data.obj.purchaseContractInvocieProductVoList
            this.waitTicketCollectionList.forEach((item, index) => {
              this.waitTicketCollectionList[index].maxCount = item.count
              this.waitTicketCollectionList[index].id = index
            })
            this.bigArray = JSON.parse(
              JSON.stringify(this.waitTicketCollectionList)
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    onUpdataState () {
      const params = {
        pcbId: this.$route.query.pcbId,
        amount: this.countAll / 100,
        purchaseContractInvocieInfoVo: {},
        purchaseContractInvocieProductVoList: this.ticketCollectionList
      }
      // const data = {
      //   invoiceType: this.queryParams.invoiceType, // invoiceType
      //   bilingType: this.queryParams.bilingType, // 收票类型
      //   invoiceReceiveCompany: this.queryParams.invoiceReceiveCompany, // 收票公司
      //   invoiceNumber: this.queryParams.invoiceNumber // 发票编号
      // }
      params.purchaseContractInvocieInfoVo = this.queryParams
      if (this.$route.query.pcbId !== undefined) {
        addInvocie(params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('已申请收票，请等待审核！')
              if (this.$route.query.type === 'ticket') {
                this.$router.push({
                  name: 'notChecksContractList',
                  query: {
                    type: this.$route.query.type,
                    pcbId: this.$route.query.pcbId
                  }
                })
              } else {
                this.$router.push({
                  name: 'contractDetails',
                  query: {
                    type: this.$route.query.type,
                    pcbId: this.$route.query.pcbId
                  }
                })
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        params.purchaseMergePageVoList = this.$store.state.ticketState.purchaseMergePageVoList
        params.purchaseContractInvocieInfoVo = this.queryParams
        delete params.pcbId
        addByMerge(params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('已申请收票，请等待审核！')
              this.$router.push({
                name: 'notChecksContractList'
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // 申请收票
    onApplyForTicketCollection () {
      if (
        this.queryParams.invoiceType === undefined ||
        this.queryParams.invoiceType === null
      ) {
        this.$message.error('请填写完整收票信息！')
      } else if (
        this.queryParams.invoiceNumber === undefined ||
        this.queryParams.invoiceNumber === null ||
        this.queryParams.invoiceNumber === ''
      ) {
        this.$message.error('请填写完整收票信息！')
      } else if (this.ticketCollectionList.length === 0) {
        this.$message.error('请设置收票产品')
      } else {
        this.title = '提交确认'
        this.content = '收票申请发起后不可撤回，是否确认收票？'
        this.$refs.OpenOrCloseRefs.onInitial()
      }
    }
  },
  watch: {
    ticketCollectionList: {
      handler (newVal) {
        this.countAll = 0
        this.ticketCollectionList.forEach((item, index) => {
          this.countAll += (item.count || 0) * item.purchasePrice * 100
        })
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.title-content-table {
  padding: 0px 0px 14px 0px;
  text-align: center;
  font-weight: 600;
}
.title-content-table-right {
  padding: 0px 20px 14px 20px;
  text-align: center;
  font-weight: 600;
}
</style>
